import { I18n } from "react-redux-i18n";
import Utilities from "../../../Helpers/Utilities";
import Constants from "../../../AppConstants/Constants";
import { receivedServerError, receivedUnauthorizedError, receivedExpiredSessionError } from "../../Error/Actions";
import { toggleBlockingStatus, updateRequestCount } from "../../Status/Actions";
import { redirectToLoginPage } from "../../Account/Actions";
import { TOPICS_RECEIVED, TOPIC_DETAILS_RECEIVED } from "../Constants";

export function getTopics() {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return fetch(Utilities.buildUrl("/Topics"), {
            ...Constants.FETCH_REQUEST_CONFIG,
            method: "GET"
        })
            .then(res => {
                if (!res.ok) {
                    throw res;
                } else {
                    return res.json();
                }
            })
            .then(json => {
                dispatch(receivedServerError(false));
                dispatch(receivedTopics(json));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.status === 401 || error.status === 403) {
                    dispatch(redirectToLoginPage());

                    if (getState().requestCount === 0) {
                        dispatch(toggleBlockingStatus(false));
                    }
                } else {
                    if (error && typeof error.text === "function") {
                        error.text().then(res => {
                            dispatch(receivedServerError(true, res));
                            dispatch(receivedServerError(false));

                            if (getState().requestCount === 0) {
                                dispatch(toggleBlockingStatus(false));
                            }
                        }).catch(e => {
                            dispatch(receivedServerError(true, I18n.t("alerts.genericError")));
                            dispatch(receivedServerError(false));

                            if (getState().requestCount === 0) {
                                dispatch(toggleBlockingStatus(false));
                            }
                        });
                    } else {
                        dispatch(receivedServerError(true, I18n.t("alerts.genericError")));
                        dispatch(receivedServerError(false));

                        if (getState().requestCount === 0) {
                            dispatch(toggleBlockingStatus(false));
                        }
                    }
                }
            });
    };
}

function receivedTopics(data) {
    return {
        type: TOPICS_RECEIVED,
        payload: data
    };
}

export function getTopicDetails(topicId) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return fetch(Utilities.buildUrl(`/Topics/TopicDetails?topicId=${topicId}`), {
            ...Constants.FETCH_REQUEST_CONFIG,
            method: "GET"
        })
            .then(res => {
                if (!res.ok) {
                    throw res;
                } else {
                    return res.json();
                }
            })
            .then(json => {
                dispatch(receivedServerError(false));
                dispatch(receivedTopicDetails(json));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.status === 401 || error.status === 403) {
                    dispatch(redirectToLoginPage());

                    if (getState().requestCount === 0) {
                        dispatch(toggleBlockingStatus(false));
                    }
                } else {
                    if (error && typeof error.text === "function") {
                        error.text().then(res => {
                            dispatch(receivedServerError(true, res));
                            dispatch(receivedServerError(false));

                            if (getState().requestCount === 0) {
                                dispatch(toggleBlockingStatus(false));
                            }
                        }).catch(e => {
                            dispatch(receivedServerError(true, I18n.t("alerts.genericError")));
                            dispatch(receivedServerError(false));

                            if (getState().requestCount === 0) {
                                dispatch(toggleBlockingStatus(false));
                            }
                        });
                    } else {
                        dispatch(receivedServerError(true, I18n.t("alerts.genericError")));
                        dispatch(receivedServerError(false));

                        if (getState().requestCount === 0) {
                            dispatch(toggleBlockingStatus(false));
                        }
                    }
                }
            });
    };
}

function receivedTopicDetails(data) {
    return {
        type: TOPIC_DETAILS_RECEIVED,
        payload: data
    };
}